export enum Status {
  /** Success */
  Success = 'SUCCESS',
  /** Failure */
  Failed = 'FAILED',
}
